import { render } from "./FileButton.vue?vue&type=template&id=22910473&scoped=true"
import script from "./FileButton.vue?vue&type=script&lang=js"
export * from "./FileButton.vue?vue&type=script&lang=js"

import "./FileButton.vue?vue&type=style&index=0&id=22910473&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22910473"]])

export default __exports__